import { Component, OnInit, ViewChild, NgZone, Inject, OnDestroy } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { DatePipe } from '@angular/common';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Subject, Subscription, debounceTime, distinctUntilChanged, takeUntil } from 'rxjs';
import { isNullOrUndefined } from 'util';
import { DataBindingDirective, GridItem, PDFService } from '@progress/kendo-angular-grid';
import { process, DataResult } from '@progress/kendo-data-query';
import { ContactService } from '../../../services/contact.service';
import { UtilityService } from '../../../services/shared/utility.service';
import { LocalService } from '../../../services/shared/local.service';
import { NotificationService } from '../../../services/notification.service';
import { Contact, ContactList, ContactListResponse } from '../../../models/contact.model';
import { CLPUser, UserResponse } from '../../../models/clpuser.model';
import { SimpleResponse, UserDD } from '../../../models/genericResponse.model';
import { CreateExportFor, eCustomSearchCategory, eExportRequestObjectType, eExportRequestStatus, eFeatures, eNoteOwnerType, eSearchType, eUserRole, SearchContactBy } from '../../../models/enum.model';
import { RoleFeaturePermissions } from '../../../models/roleContainer.model';
import { ContactSearchService } from '../../../services/shared/contact-search.service';
import { ReportService } from '../../../services/report.service';
import { TagsFields } from '../../../models/tag-settings.model';
import { CreateExportRequestObj, ExportRequest } from '../../../models/exportRequest.model';
import { ContactSearchResultObj, ContactSearchResultResponse, CustomSearchResponse } from '../../../models/report.model';
import { ContactCommonSearchService } from '../../../services/shared/contact-common-search.service';
import { GridConfigurationService } from '../../../services/shared/gridConfiguration.service';
import { ExportRequestService } from '../../../services/export-request.service';
import { SearchItem, SearchItemListResponse, SearchQuery, SearchQueryResponse } from '../../../models/search.model';
import { SendResultToNewObj } from '../../../models/report.model';
import { GlobalService } from '../../../services/global.service';
import { AppconfigService } from '../../../services/shared/appconfig.service';
import { ConfigDetails } from '../../../models/appConfig.model';
import { SearchContactService } from '../../../services/Searchcontact.service';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ContactCommonSearchComponent } from '../common/contact-common-search/contact-common-search.component';
import { MatSort, Sort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { PDFExportComponent } from '@progress/kendo-angular-pdf-export';
import { ClpCompany, CompanyResponse } from '../../../models/company.model';
import { AccountSetupService } from '../../../services/accountSetup.service';
declare var $: any;

@Component({
    selector: 'app-contact-list',
    templateUrl: './contactList.component.html',
    styleUrls: ['./contactList.component.css'],
    providers: [{ provide: 'GridConfigurationService', useClass: GridConfigurationService },
    { provide: 'GridConfigurationService1', useClass: GridConfigurationService }]
})

export class ContactListComponent implements OnInit, OnDestroy {
    private destroy$ = new Subject<void>();
    private timeouts = new Set<ReturnType<typeof setTimeout>>();
    private intervals = new Set<ReturnType<typeof setInterval>>();

    @ViewChild(ContactCommonSearchComponent) contactCommonSearchComponent!: ContactCommonSearchComponent;
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild('pdfExport') pdfExport!: PDFExportComponent;
    contactListSource = new MatTableDataSource<any>([]);
    recentContactListSource = new MatTableDataSource<any>([]);
    contactFilter = new Subject<string>();
    private encryptedUser: string = '';
    user: CLPUser;
    userResponse: UserResponse;
    roleFeaturePermissions: RoleFeaturePermissions;
    showSpinner: boolean = false;
    gridHeight;
    sendMailInfo: any = { isShow: false, contactId: 0 };
    eUserRole = eUserRole;
    exportColumnName = [
        { field: 'name', title: 'Name', width: '200' },
        { field: 'emailAddress', title: 'Email Address', width: '400' },
        { field: 'companyName', title: 'Company', width: '200' },
        { field: 'address', title: 'Address', width: '200' },
        { field: 'city', title: 'City', width: '100' },
        { field: 'state', title: 'State', width: '100' },
        { field: 'country', title: 'Country', width: '100' },
        { field: 'zip', title: 'Zip', width: '80' },
        { field: 'phone', title: 'Phone', width: '100' },
        { field: 'userName', title: 'User', width: '150' },
        { field: 'dtModifiedDisplay', title: 'Modified', width: '100' },
        { field: 'dtCreatedDisplay', title: 'Created', width: '100' },
    ]
    public contactsData: any[];
    public initContactsData: any[];
    public gridDataCount: DataResult;
    public mySelection: string[] = [];
    public recentSelectionKey: string[] = [];
    public recentContactsData: any[];
    public initRecentContactsData: any[];
    selectedId: number = 0;

    currentUrl: string = 'contacts';
    contactListResponse: ContactListResponse;
    recentContactListResponse: ContactListResponse;
    contactList: ContactList[] = [];
    recentContactList: ContactList[] = [];
    reorderColumnNameAddress: string = 'name,email,text,companyName,address,city:h,state:h,country:h,zip:h,emailAddress:h,phone,userName,dtModifiedDisplay,dtCreatedDisplay';
    reorderColumnName: string = 'name,email,text,companyName,address:h,city:h,state:h,country:h,zip:h,emailAddress:h,phone,userName,dtModifiedDisplay,dtCreatedDisplay';
    reorderColumnNameRecent: string = 'name,email,text,companyName,address:h,city:h,state:h,country:h,zip:h,emailAddress:h,phone,userName,dtModifiedDisplay,dtCreatedDisplay';
    columnWidth: string = 'name:184,email:70,text:70,companyName:159,address:142,city:102,state:102,country:102,zip:82,emailAddress:162,phone:142,userName:142,dtModifiedDisplay:104,dtCreatedDisplay:112';
    recentColumnWidth: string = 'name:184,email:70,text:70,companyName:159,address:142,city:102,state:102,country:102,zip:82,emailAddress:162,phone:142,userName:142,dtModifiedDisplay:104,dtCreatedDisplay:112';
    arrColumnWidth: any[] = ['name:184,email:70,text:70,companyName:159,address:142,city:102,state:102,country:102,zip:82,emailAddress:162,phone:142,userName:142,dtModifiedDisplay:104,dtCreatedDisplay:112'];
    arrColumnWidthRecent: any[] = ['name:184,email:70,text:70,companyName:159,address:142,city:102,state:102,country:102,zip:82,emailAddress:162,phone:142,userName:142,dtModifiedDisplay:104,dtCreatedDisplay:112'];
    sortingColumn: string = 'dtCreatedDisplay:desc';
    recentSortingColumn: string = 'dtCreatedDisplay:desc';
    arrSortingColumn: any[] = [];
    arrSortingColumnRecent: any[] = [];
    ShowAddress: boolean = false;
    reloadGridContact: boolean = true;
    isShowExports: boolean = true;
    isSearch: boolean = false;
    //For dynamic columns
    columns = [
        { field: '$', title: '', width: '40' },
        //{ field: '$$', title: '  ', width: '40' },
        { field: 'name', title: 'Name', width: '184' },
        { field: 'email', title: 'Email', width: '70' },
        { field: 'text', title: 'Text', width: '70' },
        { field: 'companyName', title: 'Company', width: '159' },
        { field: 'phone', title: 'Phone', width: '142' },
        { field: 'userName', title: 'User', width: '142' },
        { field: 'dtModifiedDisplay', title: 'Modified', width: '104' },
        { field: 'dtCreatedDisplay', title: 'Created', width: '112' },
    ];

    recentColumns: any[] = [];
    contactColumnMenuRemovedArr: any[] = [];
    recentColumnMenuRemovedArr: any[] = [];
    valueSelected: string;
    @ViewChild(DataBindingDirective) dataBinding: DataBindingDirective;

    savedQueryValue: string = '0';
    private getContactsSearchSubscription: Subscription;
    mobileColumnNames: string[] = [];

    //Tag Cloud & For Home search
    headerTitle: string = 'Tag Cloud';
    contactListTagCloud: Contact[];
    isShowContactList: boolean = false;
    searchBy: SearchContactBy = SearchContactBy.TagCloud;
    tagSearchType: number = 2;
    selectedTags: TagsFields[] = [];
    showGridChild: boolean = false;
    //isShowTagCloud: boolean = true;

    // for download button & DD
    eStat: number = eExportRequestStatus.None;
    eType: number = eExportRequestObjectType.Contact;
    exportRequest: ExportRequest;
    createExportFor: number = CreateExportFor.leadCreate;
    includeMetrics: boolean = false;
    isExportDownload: boolean = false;
    customSearchID: number = 0;
    selectedDropdownId: number = 0;
    contactValuesDD: UserDD[];
    isMyContacts: boolean = true;
    clearSearch: boolean = false;
    //Calender
    public isShowFirstMonth: boolean = false;
    public isshowSecondMonth: boolean = false;
    public nextMonthDate: Date;
    dateFormat: string;
    contactSearchResultObj: ContactSearchResultObj = <ContactSearchResultObj>{};
    selectedContactData: any;
    selectedCallType: string;
    isShowNewCallModal: boolean;

    queryDataLoaded: SearchQueryResponse = <SearchQueryResponse>{};
    subscriptionQueryList: any;
    clpUserID: any;
    dropdownData: any[] = [
        { text: 'Option 1', value: 1 },
        { text: 'Option 2', value: 2 },
        { text: 'Option 3', value: 3 }
    ];
    selectedItem: any;
    searchInput: string;
    isCloudVisible: boolean;
    isShowNewSearch: boolean = false;
    isShowPowerSearch: boolean = false;
    customSearch: SearchQueryResponse;
    searchItemListResponse: SearchItemListResponse;
    searchItems: SearchItem[] = [];
    showSaveSearch: boolean = false;
    showSaveSearchForm: boolean = false;
    searchName: string = '';
    saveSearchForm: FormGroup;
    totalContactCount: number = 0;
    contactListDisplayColumns: any[] = [];
    recentContactListDisplayColumns: any[] = [];
    pageSize: number = 10;
    exporting: boolean = false;
    exportingRecentContact: boolean;
    isLoadingContacts = true;
    columnToggleList = [
        { field: 'name', label: 'Name', checked: true },
        { field: 'email', label: 'Email', checked: true },
        { field: 'text', label: 'Text', checked: true },
        { field: 'companyName', label: 'Company', checked: true },
        { field: 'phone', label: 'Phone', checked: true },
        { field: 'userName', label: 'User', checked: true },
        { field: 'dtModifiedDisplay', label: 'Modified', checked: true },
        { field: 'dtCreatedDisplay', label: 'Created', checked: true }
    ];
    private readonly columnStorageKey = 'contact_map_grid_columns';
    companyData: ClpCompany;
    constructor(public _contactService: ContactService,
        private _utilityService: UtilityService,
        public _localService: LocalService,
        private _router: Router,
        @Inject('GridConfigurationService') public _gridCnfgService: GridConfigurationService,
        @Inject('GridConfigurationService1') public _gridCnfgServiceRecent: GridConfigurationService,
        private datePipe: DatePipe,
        private notifyService: NotificationService,
        public _contactSearchService: ContactSearchService,
        public _globalService: GlobalService,
        private _contactCommonSearchService: ContactCommonSearchService,
        private _searchContactService: SearchContactService,
        private _ngZone: NgZone,
        private _route: ActivatedRoute,
        private _reportService: ReportService,
        public _accountSetupService: AccountSetupService,
        private _appConfigService: AppconfigService,
        private fb: FormBuilder,
        private _exportService: ExportRequestService) {
        this.isCloudVisible = localStorage.getItem("isCloudVisible") ? JSON.parse(localStorage.getItem("isCloudVisible")) : true
        //this.gridHeight = this._localService.getGridHeight('499px');
        this._localService.isMenu = true;
        this.subscribeToEvents();
        _router.events.pipe(takeUntil(this.destroy$)).subscribe(event => {
            if (event instanceof NavigationEnd) {
                const url = event?.url;
                const splitUrl = url?.split('/', 4);
                this.currentUrl = splitUrl.length > 0 ? splitUrl[1] : '';
                if (this.currentUrl == 'recent-contacts') {
                    this.isMyContacts = false;
                }
            }
        });
        this._contactCommonSearchService.powerSearch.pipe(takeUntil(this.destroy$)).subscribe((value) => {
            if (value) {
                this.isShowPowerSearch = true;
                this.isShowNewSearch = false;
            }
        });
        this._contactCommonSearchService.quickSearch.pipe(takeUntil(this.destroy$)).subscribe((value) => {
            if (value) {
                this.isShowPowerSearch = false;
                this.isShowNewSearch = true;
            }
        });

    }

    ngOnInit() {
        this.saveSearchForm = this.prepareSaveSearchForm();
        this.contactValuesDD = this._localService.contactValuesDD;
        this.showSpinner = true;
        this.recentColumns = this.columns;
        this._globalService.queryList = <SearchQueryResponse>{};
        ///window.localStorage.removeItem("custom_search");
        this._globalService.getToken((token) => {
            if (token) {
                this.encryptedUser = token;
                this.authenticateR().then(() => {
                    if (this.user) {
                        this._route.queryParams
                            .pipe(takeUntil(this.destroy$)).subscribe(async params => {
                                if (params.isContactExit) {
                                    let isContactExit = +params.isContactExit;
                                    if (isContactExit > 0) {
                                        this.notifyService.showError("Contact Does Not Exist", "Contact", 5000)
                                    }
                                } else if (params.unauth) {
                                    let unauth = +params.unauth;
                                    if (unauth > 0) {
                                        this.notifyService.showError("You are not authorized to view this contact.", "Contact", 10000)
                                    }
                                }
                            });
                        this.setUpContactList();
                        this.restoreColumnState();
                        this.updateDisplayedColumns(); // ADD THIS
                    }
                    else
                        this._router.navigate(['/login']);
                });
            }
            else
                this._router.navigate(['/login']);
        });
    }

    async getClpCompany() {
        this.companyData = await this._localService.loadCompany();
        if (this.companyData == null) {
            await this._accountSetupService.getClpCompany(this.encryptedUser, this.user?.cLPCompanyID)
                .then(async (result: CompanyResponse) => {
                    if (!isNullOrUndefined(result))
                        this.companyData = UtilityService.clone(result?.company);
                })
                .catch((err: HttpErrorResponse) => {
                    this._globalService.error("configuration.getClpCompany", err.message, null,
                        'cLPCompanyID: ' + this.user?.cLPCompanyID
                    );
                    this._utilityService.handleErrorResponse(err);
                });
        }
    }

    async setUpContactList() {
        this.getClpCompany();
        this.engageMetric_Search_Filter_GET();
        /* this.getContactSearch();*/
        this.clearSearch = true;
        this.getRecentContacts();
        //this.resetGridSetting();
        //Kendo grid load call stopped.
        //this.getGridConfiguration();
        this.getContacts();
        this.defaultSearch();
        //this.getRecentGridConfiguration();
        this.getQueryDataLoad();
        this.deepSearch();
        this._appConfigService.getAppConfigValue(this.encryptedUser, "isShowNewSearch")
            .then(async (result: ConfigDetails) => {
                if (result) {
                    this.isShowNewSearch = result?.configValue == "1" ? true : false;
                }
            })
    }

    private async authenticateR() {
        this.showSpinner = true;
        await this._localService.authenticateUser(this.encryptedUser, eFeatures.ViewMyContacts)
            .then(async (result: UserResponse) => {
                if (!isNullOrUndefined(result)) {
                    await this._localService.checkIfExpiredOrUnauthorized(result?.user);
                    this.userResponse = UtilityService.clone(result);
                    this.dateFormat = this.userResponse?.user?.dateFormat;
                    if (this.userResponse) {
                        if (this.userResponse?.user) {
                            this.user = this.userResponse.user;
                            this.roleFeaturePermissions = this.userResponse.roleFeaturePermissions;
                            if (this.user?.userRole <= eUserRole.Administrator) {
                                if (this.roleFeaturePermissions?.view == false)
                                    this._router.navigate(['/unauthorized'], { state: { isMenu: true } });
                            }
                        }
                    }
                }
                this.showSpinner = false;
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("contactList.authenticateR", err.message, null, 'Features ' + eFeatures.None);
                this.showSpinner = false;
                this._utilityService.handleErrorResponse(err);
            });
    }

    private subscribeToEvents(): void {
        this._contactCommonSearchService.contactListChanged.pipe(takeUntil(this.destroy$)).subscribe((data) => {
            this._ngZone.run(() => {
                this.contactsData = data;
                this.showGridChild = false;
                this.setContactListGrid(this.contactsData);
            })
        });

        this._contactCommonSearchService.contactCountChanged.pipe(takeUntil(this.destroy$)).subscribe((data) => {
            this._ngZone.run(() => this.totalContactCount = data)
        });

        this._contactCommonSearchService.contactShowAddress.pipe(takeUntil(this.destroy$)).subscribe((data) => {
            this._ngZone.run(() => {
                this.ShowAddress = data;
                if (this.ShowAddress) {
                    if (!this.columns.some(obj => obj.field == "address")) {
                        this.columns.splice(6, 0, { field: 'address', title: 'Address', width: '70' });
                        this.contactListDisplayColumns = this.columns.map(c => c.field);
                    }
                }
                else {
                    this.columns = this.columns.filter(col => col.field !== 'address');
                    this.contactListDisplayColumns = this.contactListDisplayColumns.filter(col => col !== 'address');
                }
            })
            //this.resetGridSetting();
        });
    }


    async getContacts() {
        this.showSpinner = true;
        await this._contactService.getContacts(this.encryptedUser, this.user?.cLPUserID)
            .then(async (result: ContactListResponse) => {
                if (result) {
                    this.contactListResponse = UtilityService.clone(result);
                    this.contactList = this.contactListResponse?.contactList;
                    this.contactsData = this.transformDate(this.contactList);
                    this.setContactListGrid(this.contactsData);
                    this.totalContactCount = this.contactListResponse?.messageInt
                    this.initContactsData = UtilityService.clone(this.contactList);
                    //this._gridCnfgServiceRecent.iterateConfigGrid(this.contactList, "contact_map_grid");

                    this.contactColumnMenuRemovedArr = this.columns;
                }
                this.showSpinner = false;
            })
            .catch((err: HttpErrorResponse) => {
                console.log(err);
                this.showSpinner = false;
                this._utilityService.handleErrorResponse(err);
            });
    }

    transformDate(data) {
        data.forEach((item) => {
            item.dtCreatedDisplay = this.datePipe.transform(item.dtCreatedDisplay, 'yyyy-MM-dd');
            item.dtModifiedDisplay = this.datePipe.transform(item.dtModifiedDisplay, 'yyyy-MM-dd');
        });
        return data;
    }

    async getRecentContacts() {
        await this._contactService.getRecentContacts(this.encryptedUser, this.user?.cLPUserID)
            .then(async (result: ContactListResponse) => {
                if (!isNullOrUndefined(result)) {
                    this.recentContactListResponse = UtilityService.clone(result);
                    this.recentContactsData = this.recentContactListResponse.contactList;
                    this.initRecentContactsData = UtilityService.clone(this.recentContactsData);
                    this.setRecentContactListGrid(this.recentContactsData);
                }
            })
            .catch((err: HttpErrorResponse) => {
                console.log(err);
                this._utilityService.handleErrorResponse(err);
            });
    }

    public onTabSelect(e) {
        this.showGridChild = false;
        //this.isShowTagCloud = e.title != "Calendar";
        if (e.title == "Contacts") {
            this.isMyContacts = true;
            if (this.savedQueryValue == '0' && (isNullOrUndefined(this.getContactsSearchSubscription)))
                this.getContacts();
        }
        else if (e.title == "Calendar") {
            this._router.navigateByUrl("/calendar");
        }
        else {
            this.isMyContacts = false;
            if (this.savedQueryValue == '0' && (isNullOrUndefined(this.getContactsSearchSubscription)))
                this.getRecentContacts();
        }
    }

    public onContactsFilter(inputValue: string, isContactFilter: boolean = true): void {
        const columnName: string[] = ['name', 'email', 'companyName', 'address', 'city', 'state', 'country', 'zip', 'emailAddress', 'phone', 'searchablePhone', 'userName', 'dtModifiedDisplay', 'dtCreatedDisplay'];
        if (isContactFilter) {
            this.contactsData = process(this.initContactsData, {
                filter: {
                    logic: "or",
                    filters: this._localService.createFilterJson(columnName, inputValue),
                }
            }).data;
            this.dataBinding.skip = 0;
        } else {
            this.recentContactsData = process(this.initRecentContactsData, {
                filter: {
                    logic: "or",
                    filters: this._localService.createFilterJson(columnName, inputValue),
                }
            }).data;
            this.dataBinding.skip = 0;
        }
    }

    showColumn(columnDef): boolean {
        return columnDef ? (columnDef == 'email') || (columnDef == 'phone') ? false : true : true;
    }


    gotoLink(event: Event, columnName, dataItem) {

        if (columnName == "email") {
            $('#sendEmail').modal('show');
            this.sendMailInfo.isShow = true;
            this.sendMailInfo.contactId = dataItem?.contactID;
        }
        else if (columnName == "userName") {
            let url = '/edit-profile/' + dataItem?.clpUserId;
            return url;
        }
        else {
            this.clpUserID = dataItem.clpUserId
            if (this.user.timeZoneWinId != 0) {
                let url = '/contact/' + dataItem.contactID;
                return url;
            }
            else {
                $('#timezoneModal').modal('show');
            }
        }
    }

    hideTextMail() {
        this.selectedId = 0;
        $('#sendTextModal').modal('hide');
    }

    showTextMail(contactId) {
        this.selectedId = contactId;
        $('#sendTextModal').modal('show');
    }

    addNewContact() {
        this._router.navigate(['/contact-create']);
    }

    public saveExcel(component): void {
        this._localService.saveExcel(component, 'Contact List');
    }

    giveAccessContact() {
        return !(this.roleFeaturePermissions?.create || this.roleFeaturePermissions?.edit);
    }

    //For Tag Cloud Api
    async getContactSearchList() {
        this._globalService.havingScore = "";
        this._globalService.searchWhereClause = "";
        this.showSpinner = true;
        this.copyContactSearchValue();
        await this._reportService.getContactSearchResultList(this.encryptedUser, this.contactSearchResultObj)
            .then(async (result: ContactSearchResultResponse) => {
                if (!isNullOrUndefined(result)) {
                    //this.contactsData = UtilityService.clone(result?.contactList);
                    this.contactListTagCloud = UtilityService.clone(result?.contactList);
                    this.contactsData = this.contactListTagCloud;
                    this._reportService.setTotalContactCount(result?.contactCount);
                    if (this.contactListTagCloud?.length == 1)
                        this._router.navigate(['/contact', this.contactListTagCloud[0]?.contactID]);
                }
                this.showSpinner = false;
            })
            .catch((err: HttpErrorResponse) => {
                console.log(err);
                this._utilityService.handleErrorResponse(err);
                this.showSpinner = false;
            });
    }

    copyContactSearchValue() {
        let tagIds: number[] = [];
        this.selectedTags.forEach(item => { tagIds.push(item?.tagID) });
        this.contactSearchResultObj.clickId = 0;
        this.contactSearchResultObj.clpUserId = this.user?.cLPUserID;
        this.contactSearchResultObj.clpCompanyId = this.user?.cLPCompanyID;
        this.contactSearchResultObj.startDate = "";
        this.contactSearchResultObj.endDate = "";
        this.contactSearchResultObj.ownerType = eNoteOwnerType.Contact;
        this.contactSearchResultObj.searchContactBy = this.searchBy;
        this.contactSearchResultObj.selectedTagIds = tagIds;
        this.contactSearchResultObj.tagSearchType = this.tagSearchType;
    }

    tagCloudData(data) {
        this.selectedTags = data.selectedTags;
        this.tagSearchType = data.tagSearchType;
        this.showGridChild = true;
        this.getContactSearchList();
    }
    public trackBy(index: number, item: GridItem): any {
        return index;
    }

    downloadExport() {
        if (this.user?.userRole >= 3 || this.user?.slurpyUserId > 0) {
            if (this.isExportDownload) {
                this.createExportRequest();
                this.isExportDownload = false;
                this.includeMetrics = false;
            }
            else {
                this.isExportDownload = true;
                this.includeMetrics = false;
            }
        }
        else
            this.createExportRequest();
    }

    setExportRequest() {
        this.exportRequest = <ExportRequest>{};
        this.exportRequest.cLPUserID = this.user?.cLPUserID;
        this.exportRequest.whereClause = '';
        this.exportRequest.orderBy = '';
        this.exportRequest.objectType = this.eType;
        this.exportRequest.cLPCompanyID = this.user.cLPCompanyID;
        this.exportRequest.fileName = eExportRequestObjectType[this.eType];
        this.exportRequest.includeMetrics = this.includeMetrics;
    }

    async createExportRequest() {
        this.showSpinner = true;
        //this.setExportRequest();

        var exportRequest = <CreateExportRequestObj>{};
        exportRequest.searchQueryObj = <SearchQueryResponse>{};
        exportRequest.exportRequestObj = <ExportRequest>{};
        exportRequest.exportRequestObj.cLPUserID = this.user?.cLPUserID;
        exportRequest.exportRequestObj.whereClause = this._globalService.searchWhereClause != '' ? this._globalService.searchWhereClause : '';
        exportRequest.exportRequestObj.orderBy = '';
        exportRequest.exportRequestObj.objectType = eExportRequestObjectType.Contact;
        exportRequest.exportRequestObj.cLPCompanyID = this.user.cLPCompanyID;
        exportRequest.exportRequestObj.fileName = "contact_export";
        exportRequest.exportRequestObj.includeMetrics = this.includeMetrics;
        exportRequest.searchQueryObj = this._globalService.searchWhereClause == '' ? this.queryDataLoaded : <SearchQueryResponse>{};

        let searchType = this._globalService.searchWhereClause == '' ? eSearchType.PopUp : eSearchType.QucikSerach;
        await this._exportService.exportRequestCreate(this.encryptedUser, exportRequest, eExportRequestObjectType.Contact, searchType)
            .then(async (result: SimpleResponse) => {
                if (result) {
                    if (result?.messageBool) {
                        this.notifyService.showSuccess('Your export request has been submitted successfully.', '', 3000);
                        this.isShowExports = true;
                    }
                    else
                        this.notifyService.showError(result?.errorMsg, '', 3000);
                }
                this.showSpinner = false;
            })
            .catch((err: HttpErrorResponse) => {
                console.log(err);
                this._utilityService.handleErrorResponse(err);
                this.showSpinner = false;
            });
    }

    goToRoute(value) {
        if (this.showGridChild) {
            this.getCustomSearchIdByTag().then(() => {
                if (this.customSearchID > 0) {
                    this._localService.goToCustomSearchRoute(value, this.customSearchID);
                }
            });
        }
        else {
            this.selectedDropdownId = value;
            this._globalService.queryList = this.queryDataLoaded;
            this.getCustomSearchId().then(() => {
                if (this.customSearchID > 0) {
                    this._localService.goToCustomSearchRoute(value, this.customSearchID);
                }
            });
        }
    }

    //setLocalCustomSearch(value) {
    //    switch (value) {
    //        case "1":
    //            window.localStorage.setItem('custom_search_direct-mail', JSON.stringify(this.queryDataLoaded));
    //            this._globalService.emitQueryListChangedChange(this.queryDataLoaded)
    //            break;
    //        case "2":
    //            window.localStorage.setItem('custom_search_email-blast', JSON.stringify(this.queryDataLoaded));
    //            break;
    //        case "3":
    //            window.localStorage.setItem('custom_search_bulk-appointment', JSON.stringify(this.queryDataLoaded));
    //            break;
    //        case "4":
    //            window.localStorage.setItem('custom_search_bulk-contacts', JSON.stringify(this.queryDataLoaded));
    //            break;
    //    }
    //}

    async getCustomSearchId() {
        if (this._globalService.searchWhereClause != '' || this._globalService.havingScore != '') {
            this.showSpinner = true;
            var quickPowerCustomSearch: CustomSearchResponse = <CustomSearchResponse>{}
            quickPowerCustomSearch.customSearchID = 0;
            quickPowerCustomSearch.clpCompanyID = this.user?.cLPCompanyID;
            quickPowerCustomSearch.clpUserID = this.user?.cLPUserID;
            quickPowerCustomSearch.objectType = eNoteOwnerType.Contact
            quickPowerCustomSearch.whereClause = this._globalService.searchWhereClause;
            quickPowerCustomSearch.havingScore = this._globalService.havingScore;
            await this._reportService.getCbSendResultsToNewIndexSearch(this.encryptedUser, quickPowerCustomSearch)
                .then((result: SimpleResponse) => {
                    if (!isNullOrUndefined(result))
                        this.customSearchID = UtilityService.clone(result?.messageInt);
                    this.showSpinner = false;
                })
                .catch((err: HttpErrorResponse) => {
                    console.log(err);
                    this.showSpinner = false;
                    this._utilityService.handleErrorResponse(err);
                });
        }
        else {
            this.showSpinner = true;
            var SendResultToNewObj: SendResultToNewObj = <SendResultToNewObj>{};
            SendResultToNewObj.clpCompanyId = this.user?.cLPCompanyID;
            SendResultToNewObj.clpUserId = this.user?.cLPUserID;
            SendResultToNewObj.searchContactBy = SearchContactBy.Contact;
            SendResultToNewObj.selectedDropdownId = this.selectedDropdownId;
            SendResultToNewObj.searchQueryObj = this.queryDataLoaded;
            await this._reportService.getCbSendResultsToNewSelectedIndexChanged(this.encryptedUser, SendResultToNewObj)
                .then((result: SimpleResponse) => {
                    if (!isNullOrUndefined(result))
                        this.customSearchID = UtilityService.clone(result?.messageInt);
                    this.showSpinner = false;
                })
                .catch((err: HttpErrorResponse) => {
                    console.log(err);
                    this.showSpinner = false;
                    this._utilityService.handleErrorResponse(err);
                });
        }
    }

    resetGridData() {
        this.searchInput = "";
        this.contactFilter.next('');
        if (!isNullOrUndefined(this.contactsData) && this.contactsData.length > 0) {
            this.setContactListGrid(this.contactsData);
        }
        else
            if (!isNullOrUndefined(this.contactList)) {
                this.contactsData = this.transformDate(this.contactList);
                this.setContactListGrid(this.contactsData);
            }
        this.clearSearch = false;
        this.addTimeout(() => {
            this.clearSearch = true;
        }, 100);
    }

    onCompanySelect(companyId) {
        return `company-create?cid=${companyId}`;
    }

    hideTextMsgModal(sms?: boolean) {
        this.selectedId = 0;
        $('#sendTextModal').modal('hide');
    }

    async openModalNewCall(contact, callType: string) {
        this.selectedContactData = contact
        this.selectedCallType = callType;
        this.isShowNewCallModal = true;
    }

    hideSendMail() {
        $('#sendEmail').modal('hide');
        this.sendMailInfo.isShow = false;
        this.sendMailInfo.contactId = 0;
    }

    async hideTextCallModal() {
        $('#newCallCreateModal').modal('hide');
        this.isShowNewCallModal = false;
    }


    getQueryDataLoad() {
        this.subscriptionQueryList = this._contactCommonSearchService.getqueryListChangedChangeEmitter().pipe(takeUntil(this.destroy$)).subscribe((data) => {
            this._ngZone.run(() => {
                this.queryDataLoaded = data;
                if (isNullOrUndefined(this.queryDataLoaded))
                    this.defaultSearch();
                else
                    this.getCustomSearchId();
            })
        });
    }

    defaultSearch() {
        this.selectedDropdownId = 0;
        var searchQuery: SearchQuery = <SearchQuery>{};
        searchQuery.cLPUserID = this.user.cLPUserID;
        searchQuery.controlType = "md";
        searchQuery.operator = "IN";
        searchQuery.searchItem = "CLPUserID";
        searchQuery.searchItemValue = this.user.cLPUserID.toString();
        searchQuery.tableName = "contact";
        this.queryDataLoaded = <SearchQueryResponse>{};
        this.queryDataLoaded.searchQueryList = [];
        this.queryDataLoaded.searchQueryList.push(searchQuery);
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();

        this.timeouts.forEach(id => clearTimeout(id));
        this.timeouts.clear();

        this.intervals.forEach(id => clearInterval(id));
        this.intervals.clear();
    }

    toggleCloudVisibility() {
        this.isCloudVisible = !this.isCloudVisible
        localStorage.setItem("isCloudVisible", JSON.stringify(this.isCloudVisible))
    }

    isRunSearch(event) {
        this.showSaveSearch = true;
        this.showSaveSearchForm = false;
        let cSearch = this._globalService.queryList;
        if (cSearch != undefined) {
            this.customSearch = cSearch;
        }
    }

    getOperatorName(operator) {
        let opName = ''
        switch (operator) {
            case "=":
                opName = 'Equal'
                break;
            case "<>":
                opName = 'Not Equal'
                break;
            case "LIKE":
                opName = 'Contains'
                break;
            case "IN":
                opName = 'Contains Any'
                break;
            case "NOT IN":
                opName = 'Does Not Contain'
                break;
            case "CA":
                opName = 'Contains All'
                break;
            case "R":
                opName = 'Range'
                break;
            case "dt":
                opName = 'Date'
                break;
            case ">":
                opName = 'Greater Than'
                break;
            case "<":
                opName = 'Less Than'
                break;
            case ">=":
                opName = 'Greater Than Equal To'
                break;
            case "<=":
                opName = 'Less Than Equal To'
                break;
            case "NOT LIKE":
                opName = 'Does Not Contain'
                break;
            case "STARTS":
                opName = 'Starts With'
                break;
            case "ENDS":
                opName = 'Ends With'
                break;

        }
        return opName;
    }

    async getContactSearch() {
        await this._searchContactService.getSearchFields(this.encryptedUser, this.user.cLPCompanyID)
            .then(async (result: SearchItemListResponse) => {
                if (result) {
                    this.searchItemListResponse = UtilityService.clone(result);
                    let sortedSearchItems = this.searchItemListResponse.searchItems.sort((a, b) => a.displayValue.localeCompare(b.displayValue));
                    this.searchItems.push(...sortedSearchItems);

                    this.clearSearch = true;

                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("contactList.getContactSearch", err.message, null,
                    'cLPCompanyID: ' + this.user.cLPCompanyID
                );
                this._utilityService.handleErrorResponse(err);
            });
    }

    async engageMetric_Search_Filter_GET() {
        await this._searchContactService.engageMetric_Search_Filter_GET(this.encryptedUser, this.user.cLPCompanyID)
            .then(async (result: SearchItemListResponse) => {
                if (result) {
                    if (result?.searchItems?.length > 0) {
                        this.searchItems.push(result?.searchItems[0])
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("contactList.engageMetric_Search_Filter_GET", err.message, null,
                    'cLPCompanyID: ' + this.user.cLPCompanyID
                );
                this._utilityService.handleErrorResponse(err);
            });
    }

    getSearchItemName(searchItem) {
        let itemName = '';

        let searchObj = this.searchItems?.filter((item) => item?.columnName == searchItem?.searchItem)[0];
        switch (searchItem?.controlType) {
            case 'md':
                let valuesArr = searchItem?.searchItemValue.split(",").map(Number);
                itemName = searchObj?.itemData
                    .filter(item => valuesArr.includes(item.value))
                    .map(item => item.display)
                    .join(", ");
                break;
            case 't':
                itemName = searchItem?.searchItemValue;
                break;
            case 'dt':
                itemName = searchItem?.strDtStart + " - " + searchItem?.strDtEnd;
                break;
            case 'd':
                itemName = searchObj?.itemData
                    .filter(item => item?.value == searchItem?.searchItemValue)[0]?.display
                break;
        }

        return itemName;
    }

    private prepareSaveSearchForm(): FormGroup {
        return this.fb.group({
            SearchQueryName: ['', [Validators.required]]
        });
    }

    SubmitSearch() {
        if ((this.saveSearchForm.valid)) {
            this.showSpinner = true;
            let searchQueryName = this.saveSearchForm.controls['SearchQueryName'].value
            this._searchContactService.SavedSearchQueries_Update(this.encryptedUser, this.customSearch, this.user.cLPUserID, 0, searchQueryName, eCustomSearchCategory.Contact)
                .then(res => {
                    if (res) {
                        var response = UtilityService.clone(res);
                        this.saveSearchForm.reset();
                        this.saveSearchForm.get('SearchQueryName').setValue('');
                        this.contactCommonSearchComponent.getContactSearch();
                        this.notifyService.showSuccess("Search Query has been saved successfully!", "", 3000);
                        this.showSaveSearch = false;
                        this.showSpinner = false;
                    }
                    else {
                        this.notifyService.showError("Error during Submitting Search. Please contact administrator!", "", 3000);
                        this.showSpinner = false;
                    }
                }).catch((err: HttpErrorResponse) => {
                    this.showSpinner = false;
                    this._utilityService.handleErrorResponse(err);
                });
        }
        else {
            if (!this.saveSearchForm.valid)
                this.validateAllFormFields(this.saveSearchForm);
        }
    }

    validateAllFormFields(formGroup: FormGroup) {
        Object.keys(formGroup.controls).forEach(field => {
            const control = formGroup.get(field);
            if (control instanceof FormControl) {
                control.markAsTouched();
                control.updateValueAndValidity();
            } else if (control instanceof FormGroup) {
                this.validateAllFormFields(control);
            }
        });
    }

    get saveSearchFrm() {
        return this.saveSearchForm.controls;
    }

    setTotalContactCount(event: number) {
        this.totalContactCount = event;
    }

    checkCurrentUrl() {

        if (isNullOrUndefined(this.checkCurrentUrl) || this.currentUrl == '' || this.currentUrl == 'contacts') {
            return 'contacts';
        }
        else {
            return 'recent-contacts';
        }

        //if (this.currentUrl?.includes('contacts') || this.currentUrl == '') {
        //    return 'contacts';
        //}
        //return '';
    }

    onPageChange(event: any) {
        localStorage.setItem('pageSize', event.pageSize);
    }


    async setContactListGrid(list) {
        this.isLoadingContacts = true;

        this.updateDisplayedColumns();
        if (list && list.length > 0) {
            this.contactListSource = new MatTableDataSource<any>(list);
        } else {
            this.contactListSource.data = list || [];
        }
        this.isLoadingContacts = false;

        this.addTimeout(() => {
            this.contactListSource.paginator = this.paginator;

            if (this.paginator) {
                this.paginator.pageSize =
                    this._localService.getPageSize('contact_map_grid') || 50;
            }

            if (this.sort) {
                this.contactListSource.sort = this.sort;

                const sortState = this._localService.getSortState('contact_map_grid');

                this.sort.active = sortState?.active;
                this.sort.direction = sortState?.direction;
                this.sort.sortChange.emit(sortState);
            }
        }, 500);
    }

    setRecentContactListGrid(list) {
        this.recentContactListDisplayColumns = this.columns.map(c => c.field);
        this.recentContactListSource.data = list;
        this.addTimeout(() => {
            this.recentContactListSource.paginator = this.paginator;
            if (this.paginator) {
                this.paginator.pageSize = this._localService.getPageSize('contact_map_grid') ? this._localService.getPageSize('contact_map_grid') : 50;
            }
            if (this.sort) {
                this.recentContactListSource.sort = this.sort;
                const sortState: Sort = this._localService.getSortState('contact_map_grid');
                this.sort.active = sortState?.active;
                this.sort.direction = sortState?.direction;
                this.sort.sortChange.emit(sortState);
            }
        }, 500);
    }

    getSerialNumber(index: number): number {
        return index + 1 + (this.paginator?.pageIndex || 0) * (this.paginator?.pageSize || 5);
    }

    deepSearch() {
        this.contactFilter.pipe(debounceTime(3000), distinctUntilChanged()).pipe(takeUntil(this.destroy$)).subscribe(value => {
            let filterValue = value.trim().toLowerCase();
            if (!isNullOrUndefined(filterValue) && filterValue != "")
                this.getCustomSearch_Filter(filterValue);
            else {
                this.setContactListGrid(this.contactsData);
                this.isSearch = false;
            }
        });
    }

    applyFilter(filterValue: string = '') {
        filterValue = filterValue?.trim()?.toLowerCase();
        if (this.contactListSource) {
            this.contactListSource.filterPredicate = (data: any, filter: string) => {
                return Object.keys(data).some((key) => {
                    return data[key]?.toString().toLowerCase().includes(filter);
                });
            };

            this.contactListSource.filter = filterValue;
        }
    }

    exportPDF() {

        this.exporting = true;
        this.addTimeout(() => {
            this.pdfExport.saveAs('ContactsList.pdf');
        }, 100);
        this.addTimeout(() => {
            this.exporting = false;
        }, 500);
    }

    exportPDFRecentContact() {

        this.exportingRecentContact = true;
        this.addTimeout(() => {
            this.pdfExport.saveAs('RecentContactList.pdf');
        }, 100);
        this.addTimeout(() => {
            this.exportingRecentContact = false;
        }, 500);
    }

    getCustomSearch_Filter(filterValue: string) {
        this.isSearch = true;
        this._searchContactService.customSearch_Get(this.encryptedUser, this.user.cLPUserID, filterValue)
            .then(res => {
                if (res) {
                    var response = UtilityService.clone(res);
                    this.setContactListGrid(response.contactList);
                    this.isSearch = false;
                    if (response.contactList) {
                        response.contactList?.forEach((item) => {
                            if (this.contactsData && this.contactsData.some(c => c.contactID == item.contactID) == false)
                                this.contactsData.push(item);
                        });
                    }
                }
                else
                    this.isSearch = false;
            }).catch((err: HttpErrorResponse) => {
                this.showSpinner = false;
                this.isSearch = false;
                this._utilityService.handleErrorResponse(err);
            });
    }

    addTimeout(callback, timeout) {
        const id = setTimeout(() => {
            if (callback) {
                callback();
            }
            this.timeouts.delete(id);
        }, timeout);
        this.timeouts.add(id);
    }

    async getCustomSearchIdByTag() {
        this.showSpinner = true;
        let tagIds: number[] = [];
        this.selectedTags.forEach(item => { tagIds.push(item?.tagID) });
        var SendResultToNewObj: SendResultToNewObj = <SendResultToNewObj>{};
        SendResultToNewObj.clpCompanyId = this.user?.cLPCompanyID;
        SendResultToNewObj.clpUserId = this.user?.cLPUserID;
        SendResultToNewObj.searchContactBy = SearchContactBy.TagCloud;
        SendResultToNewObj.selectedDropdownId = 4;
        SendResultToNewObj.selectedTagIds = tagIds;
        SendResultToNewObj.tagSearchType = this.tagSearchType;
        SendResultToNewObj.ownerType = 2;
        await this._reportService.getCbSendResultsToNewSelectedIndexChanged(this.encryptedUser, SendResultToNewObj)
            .then((result: SimpleResponse) => {
                if (!isNullOrUndefined(result))
                    this.customSearchID = UtilityService.clone(result?.messageInt);
                this.showSpinner = false;
            })
            .catch((err: HttpErrorResponse) => {
                console.log(err);
                this.showSpinner = false;
                this._utilityService.handleErrorResponse(err);
            });

    }

    updateDisplayedColumns() {
        const hiddenFields = this.columnToggleList
            .filter(c => !c.checked)
            .map(c => c.field);

        this.contactListDisplayColumns = this.columns
            .filter(c => !hiddenFields.includes(c.field))
            .map(c => c.field);
    }

    onColumnToggleChange() {
        this.saveColumnState();
        this.updateDisplayedColumns();
    }

    restoreColumnState() {
        const saved = localStorage.getItem(this.columnStorageKey);
        if (saved) {
            const parsed = JSON.parse(saved);

            this.columnToggleList.forEach(col => {
                const match = parsed.find(p => p.field === col.field);
                if (match) {
                    col.checked = match.checked;
                }
            });
        }
    }

    saveColumnState() {
        localStorage.setItem(
            this.columnStorageKey,
            JSON.stringify(this.columnToggleList)
        );
    }
}

